module.exports = __webpack_public_path__ + "img/brother.d479d60c.jpg";